import { formatAmount } from "../transformCoverage";

type ExcessWordingProps = {
  displayLimit: string | null;
  indemnityPeriod?: string | null;
};

export const ExcessWording = ({
  displayLimit,
  indemnityPeriod,
}: ExcessWordingProps) => {
  const formattedDisplayLimit = displayLimit ? formatAmount(displayLimit) : "";

  return (
    <>
      <strong>{formattedDisplayLimit}</strong>
      {indemnityPeriod && (
        <>
          <br />
          <strong>{indemnityPeriod}</strong>
        </>
      )}
    </>
  );
};
